import { api } from '..'
import { WISHLISTELEMENTS, GETPRODOTTOVALUES } from '../endpoint'

export const HandleWishlist = async (active, prodotto) => {
  const params = {
    object_id: prodotto.id,
  }
  if (!active) {
    const response = await api.post(WISHLISTELEMENTS, { params })
    return response.data.created
  } else {
    const response = await api.delete(WISHLISTELEMENTS, { params })
    return !response.data.success
  }
}
